import countryApi from '@/api/country.api'


const state = {
  countries: []
}


const actions = {
  async loadCountries ({ commit, state, rootState }) {
    if (state.countries.length === 0) {
      const response = await countryApi.getCountries(rootState.tenant.current)
      const countriesNorgeFirst = []
      countriesNorgeFirst.push(response.data.filter(el => el.id === 'NO')[0])
      countriesNorgeFirst.push(...response.data.filter(el => el.id !== 'NO'))
      commit('SET_COUNTRIES', countriesNorgeFirst)
    }
  }
}


const mutations = {
  SET_COUNTRIES (state, countries) {
    state.countries = countries
  }
}


export default {
  state,
  actions,
  mutations
}
